// Redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import { combineReducers } from "redux";
import userReducer from "./slices/userSlice";

// Combine reducers (if you add more later)
const rootReducer = combineReducers({
  user: userReducer,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"], // only persist user slice
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
});

// Create persistor
export const persistor = persistStore(store);
export default store;
